var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_469_182)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 19L25.59 20.41L31.17 26H19V28H31.17L25.59 33.59L27 35L35 27L27 19Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_469_182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4f86f012ff4c497692269429382b10c7.svg";
export { ForwardRef as ReactComponent };